<template>
<SlideYUpTransition :duration="animationDuration">
    <div
        @mousedown.self="isTopicComponent ? '' : closeModal()"
        v-show="show"
        :class="[{'show d-block': show}, {'d-none': !show}, {'modal-mini': type === 'mini'}]"
        :aria-hidden="!show"
        class="modal fade"
        tabindex="-1"
        role="dialog"
    >
        <div
            class="modal-dialog modal-dialog-centered"
            :class="[
                {'modal-notice': type === 'notice', [`modal-${size}`]: size},
                {'modal-dialog-topic': isTopicComponent}
            ]"
        >
            <div
                class="modal-content"
                :class="[
                    modalContentClasses,
                    transparent && 'bg-transparent',
                    gradient && !transparent ? `bg-gradient-${gradient}` : ''
                ]"
                :style="transparent && 'box-shadow: none'"
            >

                <div class="modal-header" :class="[headerClasses]" v-if="$slots.header">
                    <slot name="header"></slot>
                    <slot name="close-button">
                        <button
                            v-if="showClose"
                            @click="closeModal"
                            data-dismiss="modal"
                            aria-label="Close"
                            type="button"
                            class="close"
                        >
                            <span :aria-hidden="!show">×</span>
                        </button>
                    </slot>
                </div>
                <div class="modal-body" :class="bodyClasses">
                    <slot></slot>
                </div>
                <div class="modal-footer" :class="footerClasses" v-if="$slots.footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</SlideYUpTransition>
</template>
<script>
import { SlideYUpTransition } from 'vue2-transitions';

export default {
    name: 'modal',
    emits: ['update:show', 'close'],
    components: {
        SlideYUpTransition,
    },
    props: {
        show: Boolean,
        showClose: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: '',
            validator(value) {
                const acceptedValues = ['', 'notice', 'mini'];
                return acceptedValues.indexOf(value) !== -1;
            },
            description: 'Modal type (notice|mini|"") ',
        },
        modalClasses: {
            type: [Object, String],
            description: 'Modal dialog css classes',
        },
        size: {
            type: String,
            description: 'Modal size',
            validator(value) {
                const acceptedValues = ['', 'sm', 'lg'];
                return acceptedValues.indexOf(value) !== -1;
            },
        },
        modalContentClasses: {
            type: [Object, String],
            description: 'Modal dialog content css classes',
        },
        gradient: {
            type: String,
            description: 'Modal gradient type (danger, primary etc)',
        },
        headerClasses: {
            type: [Object, String],
            description: 'Modal Header css classes',
        },
        bodyClasses: {
            type: [Object, String],
            description: 'Modal Body css classes',
        },
        footerClasses: {
            type: [Object, String],
            description: 'Modal Footer css classes',
        },
        animationDuration: {
            type: Number,
            default: 500,
            description: 'Modal transition duration',
        },
        transparent: {
            type: Boolean,
            default: false,
        },
        isTopicComponent: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        closeModal() {
            this.$emit('update:show', false);
            this.$emit('close');
        },
    },
    watch: {
        show(val) {
            const documentClasses = document.body.classList;
            if (val) {
                documentClasses.add('modal-open');
            } else {
                documentClasses.remove('modal-open');
            }
        },
    },
};
</script>
<style lang="sass">
.modal.show
    background-color: rgba(0, 0, 0, 0.3)

@media screen and (min-width: 576px)
    .modal-dialog-topic
        margin: 6.75rem auto !important

</style>
